import axiosClient from '../api/AxiosConfig';

export const RecruitService = {
  CreateRecruit: async (data) => {
    return (await axiosClient.post('/recruit', data)).data;
  },
  EditRecruit: async (id, data) => {
    return (await axiosClient.put(`/recruit/private/${id}`, data)).data;
  },
  GetRecruit: async (filter) => {
    return (await axiosClient.get('/recruit/private', { params: filter })).data;
  },
  DisableRecruit: async (id) => {
    return (await axiosClient.patch(`/recruit/private/${id}/disable`)).data;
  },
  EnableRecruit: async (id) => {
    return (await axiosClient.patch(`/recruit/private/${id}/enable`)).data;
  },
  DeleteRecruit: async (id) => {
    return (await axiosClient.delete(`/recruit/private/${id}`)).data;
  },
  GetRecruitBySlug: async (slug) => {
    return (await axiosClient.get(`/recruit/private/${slug}`)).data;
  },
};
